<template>
    <b-container fluid>
        <b-row>
            <b-col lg="6" class="my-1">    
            <b-form-group
                  label="Filtrar"
                  label-cols-sm="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="filterInput"
                  class="mb-0"
            >
                <b-input-group size="sm">
                    <b-form-input
                      v-model="filter"
                      type="search"
                      id="filterInput"
                      placeholder="Escriba para filtrar"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            </b-col>

            <b-col sm="5" md="6" class="my-1">
                <b-form-group
                  label="Por página"
                  label-cols-sm="6"
                  label-cols-md="6"
                  label-cols-lg="3"
                  label-align-sm="right"
                  label-size="sm"
                  label-for="perPageSelect"
                  class="mb-0"
                >
                  <b-form-select
                    v-model="perPage"
                    id="perPageSelect"
                    size="sm"
                    :options="pageOptions"
                  ></b-form-select>
            </b-form-group>
            </b-col>
        </b-row>
    <b-table 
        striped hover 
        responsive
        small
        :sticky-header="maxWidth(windowWidth)"

        :items="items" 
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"

        :filter="filter"
        :filterIncludedFields="filterOn"
        @filtered="onFiltered"

        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
         
        >
        <template v-slot:cell(acciones)="row">
            <b-button size="sm" class="mb-1" @click="cerrar(row.item, row.index, $event.target)"
                data-toggle="tooltip" data-placement="top" title="Cambia el estado de la orden a cerrada"
            >
               Cerrar
            </b-button>
        </template>
        
        <template v-slot:cell(url)="row">
            
            <b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
                ver detalles
            </b-form-checkbox>
        </template>

        <template v-slot:row-details="row">
            <b-card>
                <ul v-for="(url, key) in urls" :key="key"><!--row.item -->
                 <li v-if=" url.idsolicitud == row.item.id" >
                   
                    <b-link :href="url.link" target="_blank">{{url.link}}</b-link>
                 </li>
                </ul>
            </b-card>
        </template>
        
        <template v-slot:cell(comentario_ingenieria)="row">
                 <ul v-for="(comentario, key) in comentarios" :key="key"><!--row.item -->
                        <li v-if=" comentario.salesid == row.item.id" >
                   
                            {{comentario.comentario}}
                        </li>
                    </ul>
        </template>

    </b-table>
    <!-- Info modal -->
    <b-modal :id="infoModal.id"  :title="infoModal.title" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit">  
            <b-form-group
                :state="commentState"
                label="Comentario"
                label-for="name-input"
                invalid-feedback="comantario es requerido"
              >
                <b-form-input
                  id="name-input"
                  v-model="infoModal.comentario"
                  :state="commentState"
                  required
                ></b-form-input>

              </b-form-group>
        </form>  
    </b-modal>

        <!-- Paginacion -->
        <b-pagination
            v-model="currentPage"
            :total-rows="items.length"
            :per-page="perPage"
            align="center" 
            class="my-0"
            >
        </b-pagination> 

    </b-container>
</template>

<script>
    import {mapActions,mapMutations,mapState} from 'vuex'
    //import userForm from '@/components/admin/userForm'
    import validateMixin from '@/mixins/validation' //para usar el mixin de vee-validate
    import customMixin from '@/mixins/customMixin'
    export default {
        components:{
            //userForm
        },  
        mixins : [validateMixin,customMixin],
        props:{
            items:{
                type: Array,
                required: true
            },
            fields:{
                type: Array,
                required:true
            },
            urls:{
                type: Array,
                required: true
            },
            comentarios:{
                type: Array,
                required: true    
            }
        },
        data:function(){
            return{
                currentPage: 1,
                perPage: 10,
                pageOptions: [10, 50, 100],
                sortBy: '',
                sortDesc: false,
                sortDirection: 'asc',

                infoModal: {
                    id: 'info-modal',
                    title: '',
                    comentario: ''
                },
                item:[],
                commentState: null,
                filter:'',
                filterOn: [],
                totalRows: 1,
                disable: false
                
               
            }
               
        },
        computed:{
            ...mapState(['windowWidth']),//llamamos al estado.
        },
          
        methods:{
            ...mapActions({
                _cerrar: 'preprensa/cerrarOrden',  
                _comentario: 'preprensa/comentario' 
            }),
            ...mapMutations({
                //_setUser: 'admin/setUser'
            }),
             
            
            cerrar(item, index, button) {
                this.infoModal.title = `Está seguro que desea cerrar la orden #: ${item.id}`
                this.item = item
                this.$root.$emit('bv::show::modal', this.infoModal.id, button)
            },
            async handleSubmit() {
                let payload
                let url = "api/preprensacerrar"//direccion de la api
                let values = new FormData()
                payload =
                    {'id':  this.item.id, 
                    'comentario' : this.infoModal.comentario
                    }
                values.append('id',payload.id)
                values.append('comentario',payload.comentario)    
                try{
                    await this.axios({
                        method:'POST',
                        url: url,
                        data: values
                    })
                    this.clearErrors()   
                    this.$router.go(0) 
                }  catch(error){
                    this.$toasted.show(error, {
	 					duration : 3000
						})
                    
                }
            },
            resetModal() {
               this.infoModal.comentario = ''
               
            },
            handleOk(bvModalEvt) {

              // Prevent modal from closing
              bvModalEvt.preventDefault()
              // Trigger submit handler
              this.handleSubmit()
            },
           /* checkFormValidity() {
                const valid = this.$refs.form.checkValidity()
                this.commentState = valid
                return valid
            },*/
            onFiltered(filteredItems) {
                this.totalRows = filteredItems.length
                this.currentPage = 1
            },
            clearErrors(){
                this.reset = true
                this.errors.clear();
                this.$validator.reset()
            }
        }//methods
        
    }//export
</script>

<style lang="scss" scoped>


</style>